import api from "../config/api";

export const subscriptionService = {
  getCurrent: async () => {
    const response = await api.get("/subscriptions/current");
    return response.data;
  },

  /**
   * Creates a Razorpay order on the backend.
   * For COD, directly activates the subscription.
   *
   * @param {string} tier           - 'free' | 'monthly' | 'yearly'
   * @param {string} paymentMethod  - 'razorpay' | 'cod'
   */
  purchase: async (tier, paymentMethod = "razorpay") => {
    const response = await api.post("/subscriptions/purchase", {
      tier,
      payment_method: paymentMethod,
    });
    return response.data;
  },

  /**
   * Verifies Razorpay payment signature on the backend.
   * Must be called after the Razorpay popup succeeds.
   *
   * @param {Object} payload
   * @param {string} payload.razorpay_order_id
   * @param {string} payload.razorpay_payment_id
   * @param {string} payload.razorpay_signature
   * @param {string} payload.subscription_id  - Internal subscription UUID
   */
  verifyPayment: async (payload) => {
    const response = await api.post("/subscriptions/razorpay/verify", payload);
    return response.data;
  },

  upgrade: async (tier) => {
    const response = await api.post("/subscriptions/upgrade", { tier });
    return response.data;
  },

  cancel: async (reason) => {
    const response = await api.post("/subscriptions/cancel", { reason });
    return response.data;
  },

  purchaseAutoRenew: async (tier) => {
    const response = await api.post("/subscriptions/auto-renew", { tier });
    return response.data;
  },

  getHistory: async (limit = 10) => {
    const response = await api.get("/subscriptions/history", {
      params: { limit },
    });
    return response.data;
  },

  toggleAutoRenew: async (enable) => {
    const response = await api.post("/subscriptions/toggle-auto-renew", { enable });
    return response.data;
  },
};

export default subscriptionService;
